function o(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n, t) {
    a[++e] = [t, n];
  }), a;
}
export {
  o as default
};
